import React from "react";
import api from "../../actions/common";
import AuthContext from "../../contexts/AuthContext";
import { navigate } from "hookrouter";
import cogoToast from "cogo-toast";
import firebase from "firebase/app";
import "firebase/auth";

export const useAuth = () => {
  const [loading, setLoading] = React.useState(false);

  const { token, setToken, user, setUser, expire } = React.useContext(
    AuthContext
  );

  const init = () => initialize(user, setToken, setUser, setLoading);

  const login = (formdata) =>
    postLogin(formdata, token, setLoading, setToken, setUser);

  const signup = (formdata) =>
    postRegister(formdata, token, setLoading, setToken, setUser);

  const sendReset = (formdata) =>
    postSendResetCode(formdata, token, setLoading);

  const reset = (formdata, resetCode) =>
    postReset(formdata, resetCode, token, setLoading);

  const loginGoogle = () => firebaseGoogleAuth(setLoading, setToken, setUser);

  const confirmEmail = (args) => getConfirmEmail(null, args, setLoading);

  const logout = () => handleLougout(user, setUser, setToken);

  return {
    token,
    login,
    logout,
    signup,
    loginGoogle,
    sendReset,
    reset,
    confirmEmail,
    loading,
    init,
  };
};

const handleLougout = (user, setUser, setToken) => {
  localStorage.removeItem("user");
  localStorage.removeItem("token");
  localStorage.removeItem("authType");
  setUser(null);
  setToken(null);
  if (user?.authType === "google") {
    firebase
      .auth()
      .signOut()
      .then(
        () => {
          console.log("f");
          navigate("/");
        },
        (error) => {
          console.error("Sign Out Error", error);
        }
      );
  } else {
    navigate("/");
  }
};

const initialize = async (user, setToken, setUser, setLoading) => {
  setLoading(true);
  const localUser = JSON.parse(localStorage.getItem("user"));
  const localToken = localStorage.getItem("token");
  const localAuthType = localStorage.getItem("authType");

  if (user?.authType === "google" || localAuthType === "google") {
    firebase.auth().onAuthStateChanged((user) => {
      user.getIdToken(true).then((firetoken) => {
        if (firetoken) {
          setToken(firetoken);
        } else {
          handleLougout(user, setUser, setToken);
        }
      });
    });
  } else if (localUser && localToken) {
    setToken(localToken);
    setUser({ ...localUser, authType: "email" });
  } else {
    handleLougout(user, setUser, setToken);
  }
  setLoading(false);
};

const postLogin = async (formdata, token, setLoading, setToken, setUser) => {
  const resp = await api.set("/auth/login", token, formdata, setLoading, {
    json: true,
    raw: true,
  });

  if (resp.success) {
    const token = resp.raw.headers.get("x-auth-token");
    console.log(token);
    localStorage.setItem("token", token);
    localStorage.setItem("user", JSON.stringify(resp.content));
    localStorage.setItem("authType", "email");
    setToken(token);
    setUser({ ...resp.user, authType: "email" });
    navigate("/");
  }
};

const postSendResetCode = async (formdata, token, setLoading) => {
  const resp = await api.set(
    "/auth/forgot-password",
    token,
    formdata,
    setLoading,
    {
      json: true,
    }
  );

  if (resp.success) {
    cogoToast.success("Email Sent");
    navigate("/reset");
  } else {
    cogoToast.success("Failed! ");
  }
};

const postReset = async (formdata, resetCode, token, setLoading) => {
  const resp = await api.set(
    `/auth/forgot-reset-pwd?resetLink=${resetCode}`,
    token,
    formdata,
    setLoading,
    {
      json: true,
    }
  );

  if (resp.success) {
    cogoToast.success("Successfully Reset Password");
    navigate("/login");
  } else {
    cogoToast.error(resp.message);
  }
};

const postRegister = async (formdata, token, setLoading) => {
  const resp = await api.set("/auth/register", token, formdata, setLoading, {
    json: true,
    raw: true,
  });
  console.log(resp);
  if (resp.success) {
    if (resp.content.success) {
      cogoToast.success("Verification code sent on email!");
      navigate("/verify");
    } else {
      cogoToast.error(resp.content.message);
    }
  }
};

const firebaseGoogleAuth = async (setLoading, setToken, setUser) => {
  setLoading(true);
  var provider = new firebase.auth.GoogleAuthProvider();
  provider.addScope("https://www.googleapis.com/auth/userinfo.profile");

  try {
    await firebase.auth().signInWithPopup(provider);
    const token = await firebase.auth().currentUser.getIdToken();

    console.log(token);
    const resp = await api.get("/auth/googleAuth", token, {}, setLoading);
    if (resp.success) {
      localStorage.setItem("token", token);
      localStorage.setItem("user", JSON.stringify(resp.user));
      localStorage.setItem("authType", "google");
      setToken(token);
      setUser({ ...resp.user, authType: "google" });
      navigate("/");
    } else {
      cogoToast.error("Failed");
    }
    setLoading(false);
  } catch (e) {
    console.log(e);
    setLoading(false);
  }

  // .signInAnonymously()
  // .then(function (result) {
  //   // console.log(result);
  //   firebase
  //     .auth()
  //     .currentUser.getIdToken()
  //     .then(function (idToken) {
  //       console.log(idToken);
  //     })
  //     .catch(function (error) { });
  // })
  // .catch(function (error) {
  //   console.log(error);
  // });
};

const getConfirmEmail = async (token, args, setLoading) => {
  const resp = await api.get("/auth/verify-email", token, args, setLoading);
  if (resp.success) {
    cogoToast.error("Email Confirmed");
    navigate("/login");
  } else {
    cogoToast.error(resp.message);
  }
};
